import * as Cesium from "cesium";
import { Viewer as CesiumViewer } from "cesium";
import "cesium/Build/Cesium/Widgets/widgets.css";
import React, { useEffect, useRef } from "react";
import useViewerStore from "./stores/useViewerStore";

Cesium.Ion.defaultAccessToken = process.env.REACT_APP_CESIUM_TOKEN || "";

const CesiumMap = ({ children }: { children?: React.ReactNode }) => {
  const divRef = useRef<HTMLDivElement>(null);
  const { viewer, setViewer } = useViewerStore();

  useEffect(() => {
    if (divRef.current && !viewer) {
      const v = new CesiumViewer(divRef.current, {
        animation: false,
        timeline: false,
        fullscreenButton: true,
        baseLayerPicker: true,
        geocoder: true,
        homeButton: false,
        // infoBox: false,
        sceneModePicker: false,
        selectionIndicator: false,
        navigationHelpButton: true,
        navigationInstructionsInitiallyVisible: true,
      });

      setViewer(v);
    }
  }, [setViewer, viewer]);


  useEffect(() => {
    if (viewer) {
      const position = new Cesium.Cartesian3(
        -3076123.787318728,
        4078796.354334572,
        3902956.2471823636,
      );
      viewer.camera.flyTo({
        duration: 1,
        destination: position,
        orientation: {
          heading: 6.219275859871619,
          pitch: -1.5706878936188335,
          roll: 0.0,
        },
      });
    }
  }, [viewer]);

  return (
    <div
      ref={divRef}
      style={{ width: "100dvw", height: "100dvh", backgroundColor: "green" }}
    >
      {children && children}
    </div>
  );
};

export default CesiumMap;
